import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
  Row,
  Col,
  Alert,
  Spinner
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexFooter from "components/Footers/IndexFooter.js"; // Use the IndexFooter

// API endpoint for admin login - ** Make sure this is correct **
const API_ADMIN_LOGIN_URL = "/api/auth/login"; // Default from your original code

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [feedback, setFeedback] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("register-page"); // Reusing class
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("register-page");
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFeedback({ message: '', type: '' });

    try {
      const response = await axios.post(API_ADMIN_LOGIN_URL, { email, password });
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token);
        setFeedback({ message: "✅ Login successful! Redirecting...", type: "success" });
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 1000);
      } else {
         setFeedback({ message: "❌ Login successful, but no token received.", type: "warning" });
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Login failed. Invalid credentials.";
      setFeedback({ message: `❌ ${errorMessage}`, type: "danger" });
      console.error("Admin Login error:", err.response || err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <IndexNavbar />
      <div
        className="page-header"
        style={{
          backgroundImage: "url(" + require("assets/img/login-image.jpg") + ")",
        }}
      >
        <div className="filter" />
        {/* Container centers the content horizontally */}
        <Container>
          <Row>
             {/* Column with auto margins centers the card */}
            <Col className="ml-auto mr-auto" lg="4">
              <Card className="card-register ml-auto mr-auto">
                <h3 className="title mx-auto">Admin Login</h3>
                <Form className="register-form" onSubmit={handleLogin}>
                   {feedback.message && (
                    <Alert color={feedback.type} isOpen={!!feedback.message} toggle={() => setFeedback({ message: '', type: '' })} style={{fontSize: '0.85rem', padding: '0.5rem 1rem'}}>
                      {feedback.message}
                    </Alert>
                  )}
                  <FormGroup>
                    <Label for="adminLoginEmail">Email</Label>
                     <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-email-85" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="adminLoginEmail"
                          name="email"
                          placeholder="Admin Email"
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <Label for="adminLoginPassword">Password</Label>
                     <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="adminLoginPassword"
                          name="password"
                          placeholder="Password"
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>
                  <Button block className="btn-round" color="danger" type="submit" disabled={isSubmitting}>
                     {isSubmitting ? <><Spinner size="sm" /> Logging In...</> : 'Login'}
                  </Button>
                </Form>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      
      <IndexFooter />
    </>
  );
}

export default AdminLogin;